<template>
  <Wrapper
    :position="floatFrameHover.position"
    v-if="!preview && renderTools && floatFrameHover.id && floatFrameHover.id != floatFrameActive.id"
  >
    <FloatframeHover :headerActive="headerActive">
      {{ $t(`engine.floatframeTool.floatframeActive.${floatFrameHover.name.toUpperCase()}`,languageEngine) }}
    </FloatframeHover>
  </Wrapper>
</template>
<script>
import {
  FloatframeHover,
  Wrapper,
} from "./FloatFrameHover.styled";
import { mapGetters } from "vuex";
export default {
  components: {
    FloatframeHover,
    Wrapper,
  },
  computed: {
    ...mapGetters({
      preview: "designIframe/preview",
      renderTools: "designIframe/frame/renderTools",
      floatFrameHover: "designIframe/frame/floatFrameHover",
      floatFrameActive: "designIframe/frame/floatFrameActive",
      languageEngine: "designIframe/userPreference/languageEngine",
    }),
     headerActive() {
      return this.floatFrameHover.id && this.floatFrameHover.id.includes("HEADER") ? true : false
    },
  },
  methods: {},
};
</script>
